import styled from 'styled-components/macro';

export const FormLabel = styled.label`
  text-transform: uppercase;
  font-weight: normal;
  margin: 0;
  padding: 0;
  color: ${p => p.theme.textSecondary};
  font-size: 0.75rem;
`;
